export default function initPaginationProducts() {

    if (!document.body.classList.contains('tax-categoria-produto')) {
        return;
    }

}